<template>
    <el-container class="mainJjglBody">
        <el-col class="box">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="mainTitle">经济机构公示</span>
                </div>
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-row>
                        <el-form-item label="机构名称">
                            <el-input v-model="formInline.dwmc" placeholder="输入从业机构名称"></el-input>
                        </el-form-item>
                        <span class="cxzxClass1">
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">查询</el-button>
                                <el-button @click="resetHt">重置</el-button>
                            </el-form-item>
                        </span>
                    </el-row>
                </el-form>
            </el-card>
            <div v-show="sfxs_ht">
                <el-table
                        :data="tableData5"
                        style="width: 100%"
                        class="tableBox"
                        :header-cell-class-name="ClassName_JjglBiaotou"
                        :row-class-name="tableRowClassName">
                    <el-table-column
                            header-align="center"
                            prop="DWQCH"
                            label="公司名称"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            prop="PJL"
                            label="评价率"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            prop="MYD"
                            label="满意度"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            label="信用档案"
                            align="center">
                        <template slot-scope="scope">
                            <a @click="OpenJgXx(scope.row.DWXH)">
                                查看
                            </a>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        next-text="下一页"
                        :small="true"
                        :page-size="5"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :total="totalCount"
                >
                </el-pagination>
            </div>
        </el-col>
    </el-container>
</template>

<script>
    import {mapActions} from "vuex";
    export default {
        data() {
            return {
                formInline: {
                    dwmc: '',
                },
                sfxs_ht:true,
                jjjgccxjg:{},
                reverse: true,
                value: '',
                currentPage:1, //初始页
                pagesize:10,    //    每页的数据
                totalCount:50,
                papercount:5,
                tableData5:[
                    {
                        DWQCH:'张三房地产有限公司',
                        PJL:'844',
                        MYD:'0',
                        DWXH:'1',
                    },
                    {
                        DWQCH:'张三房地产有限公司',
                        PJL:'844',
                        MYD:'0',
                        DWXH:'2',
                    },
                    {
                        DWQCH:'张三房地产有限公司',
                        PJL:'844',
                        MYD:'0',
                        DWXH:'3',
                    },
                    {
                        DWQCH:'张三房地产有限公司',
                        PJL:'844',
                        MYD:'0',
                        DWXH:'0',
                    },
                    {
                        DWQCH:'张三房地产有限公司',
                        PJL:'844',
                        MYD:'0',
                        DWXH:'0',
                    },
                    {
                        DWQCH:'张三房地产有限公司',
                        PJL:'844',
                        MYD:'0',
                        DWXH:'0',
                    },
                    {
                        DWQCH:'张三房地产有限公司',
                        PJL:'844',
                        MYD:'0',
                        DWXH:'0',
                    },
                    {
                        DWQCH:'张三房地产有限公司',
                        PJL:'844',
                        MYD:'0',
                        DWXH:'0',
                    },
                    {
                        DWQCH:'张三房地产有限公司',
                        PJL:'844',
                        MYD:'0',
                        DWXH:'0',
                    },
                    {
                        DWQCH:'张三房地产有限公司',
                        PJL:'844',
                        MYD:'0',
                        DWXH:'0',
                    },
                ],
            }
        },
        methods: {
            ...mapActions([
                'HtxxSelect','Ymxxinit',
            ]),
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            onSubmit() {
                if(this.formInline.dwmc !=""){
                    this.Ymxxinit({_module:'TT',_method:'getJjglxxInit',dwqch:this.formInline.dwmc,"numPerPage": this.pagesize,"pageNum": this.currentPage,cxlx:"1"}).then((res) => {
                        if (res._page.results !=null ) {
                            /*业务信息list*/
                            this.tableData5 = res._page.results;
                            this.totalCount=res._page.count;
                        }else{
                            this.warnMessage("没有查到信息，请检查单位名称")
                        }
                    })
                }else{
                    this.warnMessage("单位名称不能为空");
                }
            },
            resetHt(){
                this.formInline.dwmc='';
                this.handleUserList();
            },
            ClassName_JjglBiaotou({row, column, rowIndex, columnIndex}) {
                return 'class_FirstBiaotou';
            },
            tableRowClassName_tableLieSszhq({row, column, rowIndex, columnIndex}) {
                if ( columnIndex==0) {
                    return 'table_firstLie0';
                }
                return '';
            },
            tableRowClassName({row, rowIndex}) {
                if ( rowIndex%2 !=0) {
                    return '';
                } else if (rowIndex%2 ==0) {
                    return 'success-row';
                }
                return '';
            },
            // 初始页currentPage、初始每页数据数pagesize和数据data
            handleSizeChange: function (size) {
                this.pagesize = size;
                console.log(this.pagesize)  //每页下拉显示数据
            },
            handleCurrentChange: function(currentPage){
                this.currentPage = currentPage;
                console.log(this.currentPage)  //点击第几页
                this.handleUserList();
            },
            handleUserList() {
                this.Ymxxinit({_module:'TT',_method:'getJjglxxInit',"numPerPage": this.pagesize,"pageNum": this.currentPage,cxlx:"1"}).then((res) => {  //这是从本地请求的数据接口，
                    this.tableData5 = res._page.results;
                    this.totalCount=res._page.count;
                })
            },
            OpenJgXx(id){
                this.$router.push({path:'/ywhome/jjgl/jjjggs_cx',query:{id:id}})
            },
        },
        created() {
            this.handleUserList()
        }
    }
</script>
<style>
    @import "../../assets/css/jjgl/jjgl_main.css";
    .el-table .success-row {
        background: #f9fbfc;
    }
    .mainJjglBody .tableBox tr{
        height: 55px;
    }
    .mainJjglBody .class_FirstBiaotou{
        border-right:1px solid #EBEEF5 !important;
        background-color: #F3FAFF;
        color: #00448c;
        font-size: 14px;
    }
    .el-pagination{
        margin-top: 30px;
        display: flex;
        justify-content: center;
    }
</style>

